export const appointmentsIt: Record<string, string> = {
  // Appointments (customer portal)
  'my_appointments': 'I Miei Appuntamenti',
  'view_appointment_photos': 'Visualizza le foto e i dettagli del tuo appuntamento',
  'upcoming': 'Prossimi',
  'past': 'Passati',
  'no_past_appointments': 'Nessun appuntamento passato',
  'no_appointments_message': 'Non hai appuntamenti {filter} al momento.',
  'consultation': 'Consulenza',
  'fitting': 'Prova',
  'final_fitting': 'Prova Finale',
  'alteration': 'Modifica',
  'photos': 'Foto',
  'no_photos_yet': 'Nessuna foto ancora',
  'photos_appear_here': 'Le foto del tuo appuntamento appariranno qui una volta caricate dal nostro team.',
  'photo_downloaded': 'Foto scaricata con successo',
  'photo_download_failed': 'Impossibile scaricare la foto',
  'customer_information_not_available': 'Informazioni cliente non disponibili',
  'failed_to_load_appointments': 'Impossibile caricare gli appuntamenti',
  'appointment_photo': 'Foto Appuntamento',
  'check_out_photo': 'Guarda questa foto dal mio appuntamento',
  'upcoming_appointments': 'Appuntamenti Prossimi',
  'appointments.editAppointment': 'Modifica Appuntamento',

  // Appointments page (admin)
  'appointments.title': 'Appuntamenti',
  'appointments.subtitle': 'Gestisci appuntamenti e consulenze dei clienti',
  'appointments.newAppointment': 'Nuovo Appuntamento',
  'appointments.errors.loadFailed': 'Impossibile caricare gli appuntamenti',
  'appointments.errors.fillRequired': 'Compilare tutti i campi obbligatori inclusa la sala prova',
  'appointments.success.deleted': 'Appuntamento eliminato con successo',
  'appointments.success.created': 'Appuntamento creato con successo',
  'appointments.success.updated': 'Appuntamento aggiornato con successo',
  'appointments.errors.deleteFailed': "Impossibile eliminare l'appuntamento",
  'appointments.unknownCustomer': 'Cliente Sconosciuto',
  'appointments.form.title': 'Titolo *',
  'appointments.form.titlePlaceholder': 'es., Consulenza Abito da Sposa',
  'appointments.form.customer': 'Cliente *',
  'appointments.form.selectCustomer': 'Seleziona un cliente',
  'appointments.form.type': 'Tipo *',
  'appointments.form.selectType': 'Seleziona tipo appuntamento',
  'appointments.form.startTime': 'Ora Inizio *',
  'appointments.form.endTime': 'Ora Fine *',
  'appointments.form.roomLabel': 'Sala',
  'appointments.form.selectRoom': 'Seleziona sala prova',
  'appointments.form.assignedStaff': 'Staff Assegnato',
  'appointments.form.selectStaff': 'Seleziona membro staff',
  'appointments.form.location': 'Luogo',
  'appointments.form.locationPlaceholder': 'es., Showroom Principale, Suite Privata',
  'appointments.form.description': 'Descrizione',
  'appointments.form.descriptionPlaceholder': 'Note aggiuntive su questo appuntamento',
  'appointments.form.creating': 'Creazione...',
  'appointments.form.updateButton': 'Aggiorna Appuntamento',
  'appointments.form.createButton': 'Crea Appuntamento',
  'appointments.filter.room': 'Filtra per Sala',
  'appointments.filter.roomLabel': 'Filtra per Sala:',
  'appointments.filter.allRooms': 'Tutte le Sale',
  'appointments.detailsTitle': 'Dettagli Appuntamento',
  'appointments.tabs.details': 'Dettagli',
  'appointments.tabs.photos': 'Foto',
  'appointments.detail.customer': 'Cliente',
  'appointments.detail.staff': 'Staff',
  'appointments.detail.description': 'Descrizione',
  'appointments.deleteConfirmation': 'Sei sicuro di voler eliminare questo appuntamento?',
  'appointments.actions.delete': 'Elimina Appuntamento',
  'appointments.actions.edit': 'Modifica Appuntamento',

  // Calendar
  'calendar.view.agenda': 'Agenda',
  'calendar.view.day': 'Giorno',
  'calendar.view.week': 'Settimana',
  'calendar.view.month': 'Mese',
  'calendar.action.new': 'Nuovo',
  'calendar.status.closed': 'Chiuso',
  'calendar.appointments.count': '{count} appuntamenti',
  'calendar.appointments.single': '1 appuntamento',
  'calendar.legend.title': 'Legenda',
  'calendar.no_upcoming': 'Nessun appuntamento imminente',
  'calendar.no_appointments_message': 'Crea il tuo primo appuntamento per iniziare',
  'calendar.filter.room': 'Filtra per sala',
  'calendar.filter.staff': 'Filtra per staff',
  'calendar.filter.type': 'Filtra per tipo',
  'calendar.filter.all_rooms': 'Tutte le Sale',
  'calendar.filter.all_staff': 'Tutto lo Staff',
  'calendar.filter.all_types': 'Tutti i Tipi',
  'calendar.weekdays.mon': 'Lun',
  'calendar.weekdays.tue': 'Mar',
  'calendar.weekdays.wed': 'Mer',
  'calendar.weekdays.thu': 'Gio',
  'calendar.weekdays.fri': 'Ven',
  'calendar.weekdays.sat': 'Sab',
  'calendar.weekdays.sun': 'Dom',
  'calendar.appointments.more': '+{count} altri',
  'calendar.today_label': ' (oggi)',
  'calendar.view_appointments_for': 'Visualizza appuntamenti per {date}',
  'calendar.closed': 'Chiuso',
  'calendar.holiday': 'Festivo',
  'calendar.invalid_time': 'Orario non valido',

  // Appointment types
  'appointment.consultation': 'Consulenza',
  'appointment.fitting': 'Prova',
  'appointment.final_fitting': 'Prova Finale',
  'appointment.alteration': 'Modifica',

  // Appointment form
  'appointment.edit': 'Modifica Appuntamento',
  'appointment.new': 'Nuovo Appuntamento',
  'appointment.title': 'Titolo',
  'appointment.customer': 'Cliente',
  'appointment.type': 'Tipo',
  'appointment.start_time': 'Ora di Inizio',
  'appointment.end_time': 'Ora di Fine',
  'appointment.fitting_room': 'Sala Prova',
  'appointment.staff': 'Staff',
  'appointment.location': 'Posizione',
  'appointment.description': 'Descrizione',
  'appointment.additional_notes': 'Note aggiuntive',
  'appointment.cancel': 'Annulla',
  'appointment.update': 'Aggiorna',
  'appointment.create': 'Crea',
  'appointment.save': 'Salva',
  'appointment.delete': 'Elimina',
  'appointment.warning': 'avviso',
  'appointment.can_save_with_warning': "L'appuntamento può essere salvato con 1 avviso",
  'appointment.fittings_note': 'Le prove durano tipicamente almeno 1 ora',

  // Appointment validation
  'appointment.validation.duration_warning': 'Le prove durano tipicamente almeno 1 ora',
  'appointment.validation.can_save_with_warning': "L'appuntamento può essere salvato con 1 avviso",
  'appointment.validation.warning': 'avviso',
  'appointment.validation.required': 'Questo campo è obbligatorio',
  'appointment.validation.errors_summary': '{count} errore/i trovato/i',
  'appointment.validation.warnings_summary': '{count} avviso/i',
  'appointment.validation.info_summary': '{count} messaggio/i informativi',
  'appointment.validation.details': 'Dettagli',
  'appointment.validation.all_passed': 'Tutti i controlli sono stati superati',

  // Form labels and placeholders
  'form.title_placeholder': 'Inserisci titolo appuntamento',
  'form.customer_placeholder': 'Seleziona cliente',
  'form.type_placeholder': 'Seleziona tipo',
  'form.room_placeholder': 'Seleziona camerino',
  'form.staff_placeholder': 'Seleziona membro dello staff',
  'form.location_placeholder': 'Inserisci località',
  'form.description_placeholder': 'Inserisci note aggiuntive...',
  'form.start_time_label': 'Ora inizio',
  'form.end_time_label': 'Ora fine',
  'form.no_customers': 'Nessun cliente disponibile',
  'form.no_staff': 'Nessun membro dello staff disponibile',
  'form.no_rooms': 'Nessun camerino disponibile',

  // Toast messages
  'toast.appointment_created': 'Appuntamento creato con successo',
  'toast.appointment_updated': 'Appuntamento aggiornato con successo',
  'toast.appointment_deleted': 'Appuntamento eliminato con successo',
  'toast.create_failed': 'Impossibile creare appuntamento',
  'toast.update_failed': 'Impossibile aggiornare appuntamento',
  'toast.delete_failed': 'Impossibile eliminare appuntamento',

  // Appointment form additional
  'appointment.error.organizationNotFound': 'Organizzazione non trovata',
  'appointment.error.requiredFields': 'Si prega di compilare tutti i campi obbligatori',
  'appointment.error.saveFailed': "Impossibile salvare l'appuntamento",
  'appointment.confirmation.proceedWithWarnings': 'Procedi con Avvisi?',
  'appointment.confirmation.warningsDescription': 'Questo appuntamento presenta i seguenti avvisi:\n\n{warnings}\n\nVuoi salvarlo comunque?',
  'appointment.form.customer': 'Cliente',
  'appointment.form.customerPlaceholder': 'Seleziona cliente',
  'appointment.form.searchCustomers': 'Cerca clienti...',
  'appointment.form.noCustomer': 'Nessun cliente',
  'appointment.form.type': 'Tipo',
  'appointment.form.startTime': 'Ora Inizio',
  'appointment.form.endTime': 'Ora Fine',
  'appointment.form.fittingRoom': 'Sala Prova',
  'appointment.form.fittingRoomPlaceholder': 'Seleziona sala prova',
  'appointment.form.staff': 'Staff',
  'appointment.form.staffPlaceholder': 'Seleziona membro staff',
  'appointment.form.noStaffAssigned': 'Nessun staff assegnato',
  'appointment.form.location': 'Posizione',
  'appointment.form.locationPlaceholder': 'Luogo appuntamento',
  'appointment.form.description': 'Descrizione',
  'appointment.form.descriptionPlaceholder': 'Note aggiuntive',
  'appointment.form.validatingAppointment': 'Validazione appuntamento...',
  'appointment.type.consultation': 'Consulenza',
  'appointment.type.fitting': 'Prova',
  'appointment.type.finalFitting': 'Prova Finale',
  'appointment.type.alteration': 'Modifica',
  'appointment.button.cancel': 'Annulla',
  'appointment.button.create': 'Crea',
  'appointment.button.update': 'Aggiorna',
  'appointment.button.saving': 'Salvando...',
  'appointment.button.saveAnyway': 'Salva Comunque',
  'appointment.form.title': 'Titolo',
  'appointment.form.titlePlaceholder': "Inserisci il titolo dell'appuntamento",
  'appointment.form.noCustomersFound': 'Nessun cliente trovato',
  'appointment.form.date': 'Data',
  'appointment.form.time': 'Ora',

  // Appointment actions
  'appointment.actions.moreActions': 'Altre azioni',
  'appointment.actions.editAppointment': 'Modifica appuntamento',
  'appointment.actions.quickReschedule': 'Riprogramma velocemente',
  'appointment.actions.duplicateTo': 'Duplica in...',
  'appointment.actions.customDateTime': 'Data e ora personalizzate',
  'appointment.actions.deleteAppointment': 'Elimina appuntamento',
  'appointment.actions.edit': 'Modifica',
  'appointment.actions.delete': 'Elimina',
  'appointment.actions.resyncGoogleCalendar': 'Risincronizza con Google Calendar',

  // Quick reschedule
  'appointment.reschedule.tomorrow': 'Domani',
  'appointment.reschedule.nextWeek': 'Prossima settimana',
  'appointment.reschedule.plusOneHour': '+1 ora',
  'appointment.reschedule.plusTwoHours': '+2 ore',
  'appointment.reschedule.nextMonth': 'Prossimo mese',

  // Toast messages
  'appointment.toast.rescheduled.title': 'Appuntamento riprogrammato',
  'appointment.toast.rescheduled.description': 'Spostato al {date}',
  'appointment.toast.reschedule.failed.title': 'Impossibile riprogrammare',
  'appointment.toast.reschedule.failed.description': 'Riprova o riprogramma manualmente',
  'appointment.toast.duplicated.title': 'Appuntamento duplicato',
  'appointment.toast.duplicated.description': 'Creata copia per {date}',
  'appointment.toast.duplicate.failed.title': 'Impossibile duplicare',
  'appointment.toast.duplicate.failed.description': 'Riprova',
  'appointment.toast.resync.success.title': 'Sincronizzazione Google Calendar Riuscita',
  'appointment.toast.resync.success.description': "L'appuntamento è stato sincronizzato con successo con Google Calendar",

  // Confirmation dialog
  'appointment.confirmation.confirm': 'Conferma',
  'appointment.confirmation.cancel': 'Annulla',
  'appointment.confirmation.pleaseWait': 'Attendere...',
  'appointment.aria.editForm': 'Modifica modulo appuntamento',
  'appointment.aria.createForm': 'Crea nuovo modulo appuntamento',
  'appointment.aria.selectCustomer': "Seleziona cliente per l'appuntamento",

  // Foto Appuntamento
  'appointments.photos.title': 'Foto',
  'appointments.photos.upload': 'Carica Foto',
  'appointments.photos.noPhotos': 'Nessuna foto ancora',
  'appointments.photos.uploadForType': 'Carica foto per questo appuntamento di {type}',
  'appointments.photos.uploadFirst': 'Carica Prima Foto',
  'appointments.photos.selectPhotos': 'Seleziona Foto',
  'appointments.photos.uploadLimit': 'Puoi caricare fino a {count} altre foto',
  'appointments.photos.tagOptional': 'Tag (Opzionale)',
  'appointments.photos.selectTag': 'Seleziona un tag per tutte le foto',
  'appointments.photos.noTag': 'Nessun tag',
  'appointments.photos.uploading': 'Caricamento...',
  'appointments.photos.uploadCount': 'Carica {count} Foto',
  'appointments.photos.uploadSuccess': '{count} foto caricate con successo',
  'appointments.photos.uploadError': 'Impossibile caricare la foto',
  'appointments.photos.loadError': 'Impossibile caricare le foto',
  'appointments.photos.deleteConfirm': 'Sei sicuro di voler eliminare questa foto?',
  'appointments.photos.deleteSuccess': 'Foto eliminata con successo',
  'appointments.photos.deleteError': 'Impossibile eliminare la foto',
  'appointments.photos.sharedWithBride': 'Foto condivisa con la sposa',
  'appointments.photos.hiddenFromBride': 'Foto nascosta alla sposa',
  'appointments.photos.visibilityError': 'Impossibile aggiornare la visibilità della foto',
  'appointments.photos.tagSuccess': 'Tag foto aggiornato',
  'appointments.photos.tagError': 'Impossibile aggiornare il tag della foto',
  'appointments.photos.visible': 'Visibile',
  'appointments.photos.hidden': 'Nascosta',
  'appointments.photos.hideFromBride': 'Nascondi alla sposa',
  'appointments.photos.shareWithBride': 'Condividi con la sposa',
  'appointments.photos.deletePhoto': 'Elimina foto',
  'appointments.photos.tag.front': 'Vista Frontale',
  'appointments.photos.tag.back': 'Vista Posteriore',
  'appointments.photos.tag.side': 'Vista Laterale',
  'appointments.photos.tag.detail': 'Dettaglio',
  'appointments.photos.tag.fitting': 'Progresso Prova',
  'appointments.photos.tag.alteration': 'Modifica',
  'appointments.photos.download': 'Scarica',
  'appointments.photos.editPhoto': 'Modifica Foto',
  'appointments.photos.removeBackground': 'Rimuovi Sfondo',

  // Azioni foto in blocco
  'appointments.photos.bulk.selectAll': 'Seleziona Tutto',
  'appointments.photos.bulk.selected': '{count} selezionate',
  'appointments.photos.bulk.addTag': 'Aggiungi tag',
  'appointments.photos.bulk.removeTag': 'Rimuovi tag',
  'appointments.photos.bulk.show': 'Mostra',
  'appointments.photos.bulk.hide': 'Nascondi',
  'appointments.photos.bulk.download': 'Scarica',
  'appointments.photos.bulk.delete': 'Elimina',
  'appointments.photos.bulk.deleteTitle': 'Elimina Foto Selezionate',
  'appointments.photos.bulk.deleteDescription': 'Sei sicuro di voler eliminare {count} foto selezionate? Questa azione non può essere annullata.',
  'appointments.photos.bulk.cancel': 'Annulla',
  'appointments.photos.bulk.deleteConfirm': 'Elimina Foto',

  // Caricamento drag & drop
  'appointments.photos.dragDrop.dropHere': 'Rilascia i file qui',
  'appointments.photos.dragDrop.dragAndDrop': 'Trascina e rilascia le immagini qui',
  'appointments.photos.dragDrop.or': 'oppure',
  'appointments.photos.dragDrop.browseFiles': 'sfoglia file',
  'appointments.photos.dragDrop.supports': 'Formati: JPG, PNG, GIF, WebP',
  'appointments.photos.dragDrop.maxSize': 'Dimensione max: 10MB per file',
  'appointments.photos.dragDrop.upToFiles': 'Fino a {count} file',
  'appointments.photos.dragDrop.tagOptional': 'Tag (opzionale):',
  'appointments.photos.dragDrop.selectTag': 'Seleziona un tag',
  'appointments.photos.dragDrop.selectedFiles': 'File Selezionati ({count})',
  'appointments.photos.dragDrop.clearAll': 'Cancella Tutto',
  'appointments.photos.dragDrop.uploadingFiles': 'Caricamento file...',
  'appointments.photos.dragDrop.uploadFiles': 'Carica {count} File',

  // Lightbox foto
  'appointments.photos.lightbox.untitled': 'Senza titolo',
  'appointments.photos.lightbox.ofTotal': '{current} di {total}',
  'appointments.photos.lightbox.reset': 'Ripristina',

  // Rimozione sfondo
  'appointments.photos.bgRemoval.title': 'Rimozione Sfondo',
  'appointments.photos.bgRemoval.original': 'Originale',
  'appointments.photos.bgRemoval.removed': 'Sfondo Rimosso',
  'appointments.photos.bgRemoval.processing': 'Elaborazione...',
  'appointments.photos.bgRemoval.clickToProcess': 'Clicca "Rimuovi Sfondo" per elaborare',
  'appointments.photos.bgRemoval.processingImage': 'Elaborazione immagine...',
  'appointments.photos.bgRemoval.removeButton': 'Rimuovi Sfondo',
  'appointments.photos.bgRemoval.download': 'Scarica',
  'appointments.photos.bgRemoval.saveToAppointment': "Salva nell'Appuntamento",
  'appointments.photos.bgRemoval.loadingModel': 'Caricamento modello AI...',
  'appointments.photos.bgRemoval.loadingModelDesc': 'Potrebbe richiedere un momento al primo utilizzo',
  'appointments.photos.bgRemoval.success': 'Sfondo rimosso con successo',
  'appointments.photos.bgRemoval.error': 'Impossibile rimuovere lo sfondo',

  // Confronto foto
  'appointments.photos.comparison.title': 'Confronto Foto',
  'appointments.photos.comparison.before': 'Prima',
  'appointments.photos.comparison.after': 'Dopo',
  'appointments.photos.comparison.swap': 'Scambia',
  'appointments.photos.comparison.selectTwo': 'Seleziona due foto da confrontare',
  'appointments.photos.comparison.untitled': 'Senza titolo',

  // Menu azioni intestazione
  'appointment.actions.actionsFor': 'Azioni per {title}',
  'appointment.toast.resync.failed.title': 'Sincronizzazione Fallita',
  'appointment.toast.resync.failed.description': 'Impossibile sincronizzare con Google Calendar. Riprova.',

  // Crea Appuntamento
  'appointments.create.title': 'Crea Nuovo Appuntamento',
  'appointments.create.businessHoursWarning': "Gli orari di lavoro non sono stati configurati. Contatta un amministratore per impostare gli orari prima di creare appuntamenti.",
  'appointments.create.validating': 'Validazione...',
  'appointments.create.validation.noBusinessHours': 'Gli orari di lavoro non sono stati configurati. Contatta un amministratore.',
  'appointments.create.validation.outsideHours': "L'orario dell'appuntamento è al di fuori dell'orario lavorativo.",
  'appointments.create.validation.holiday': "L'attività è chiusa nella data selezionata.",
  'appointments.create.validation.lunchBreak': "L'appuntamento è in conflitto con una pausa pranzo programmata.",
  'appointments.create.validation.invalid': 'Orario appuntamento selezionato non valido.',
  'appointments.create.validation.cannotValidate': "Impossibile validare l'orario dell'appuntamento",
  'appointments.create.validation.noBusinessHoursDay': 'Gli orari di lavoro non sono configurati per questo giorno',
  'appointments.create.validation.outsideHoursShort': "L'orario dell'appuntamento è al di fuori dell'orario lavorativo",
  'appointments.create.validation.holidayShort': 'Impossibile prenotare appuntamenti nei giorni festivi',
  'appointments.create.validation.lunchBreakShort': "L'appuntamento è in conflitto con una pausa pranzo",
  'appointments.create.failedToCreate': "Impossibile creare l'appuntamento",

  // Dettagli Appuntamento
  'appointments.detail.close': 'Chiudi',
  'appointments.detail.measurement': 'Misurazione',
  'appointments.detail.delivery': 'Consegna',
  'appointments.detail.loading': 'Caricamento Appuntamento...',
  'appointments.detail.noSelection': 'Nessun appuntamento selezionato',
  'appointments.detail.syncError': 'Errore Sincronizzazione',
  'appointments.detail.syncSynced': 'Sincronizzato',
  'appointments.detail.syncPending': 'In sincronizzazione',
  'appointments.detail.syncFailed': 'Sincronizzazione fallita',
  'appointments.detail.syncTooltipSynced': 'Sincronizzato con Google Calendar',
  'appointments.detail.syncTooltipPending': 'Sincronizzazione con Google Calendar in corso',
  'appointments.detail.syncTooltipFailed': 'Sincronizzazione con Google Calendar fallita',
  'appointments.detail.syncLastSynced': 'Ultima sincronizzazione: {date}',
  'appointments.detail.tip': 'Suggerimento: Clicca sugli appuntamenti per visualizzarli, usa il menu azioni per modificare',
  'appointments.detail.deleteTitle': 'Elimina Appuntamento',
  'appointments.detail.deleteConfirm': 'Sei sicuro di voler eliminare "{title}"? Questa azione non può essere annullata.',
  'appointments.detail.appointment': 'Appuntamento',
  'calendar.filter.filters': 'Filtri',
  'calendar.no_appointments_today': 'Nessun appuntamento per oggi',
  'calendar.aria.navigation': 'Navigazione calendario',
  'calendar.aria.filters': 'Filtri appuntamenti',
  'calendar.aria.filterByRoom': 'Filtra per sala',
  'calendar.aria.filterByStaff': 'Filtra per membro dello staff',
  'calendar.aria.filterByType': 'Filtra per tipo di appuntamento',
  'calendar.aria.viewOptions': 'Opzioni vista calendario',
  'calendar.action.previous': 'Precedente',
  'calendar.action.next': 'Successivo',
  'calendar.action.goToToday': 'Vai a oggi',
  'calendar.period.day': 'giorno',
  'calendar.period.week': 'settimana',
  'calendar.period.month': 'mese',

  // Card appuntamento
  'appointment.card.aria.viewDetails': 'Visualizza dettagli appuntamento: {title} il {date}',
  'appointment.card.title.viewDetails': 'Clicca per visualizzare i dettagli appuntamento',
  'appointment.card.aria.type': 'Tipo appuntamento: {type}',
  'appointment.card.typeLabel': 'Tipo: {type}',
  'appointment.card.aria.googleSync': 'Stato sincronizzazione Google Calendar: {status}',
  'appointment.card.sync.notSynced': 'non sincronizzato',
  'appointment.card.googleCalendar': 'Google Calendar',
  'appointment.card.syncIssue': 'Problema di sincronizzazione',
  'appointment.card.googleSyncError': 'Errore sincronizzazione Google Calendar:',

  // Operazioni batch
  'appointments.batch.title': 'Operazioni batch',
  'appointments.batch.selectOperation': 'Seleziona operazione',
  'appointments.batch.targetDate': 'Data di destinazione',
  'appointments.batch.selectAppointments': 'Seleziona appuntamenti ({selected}/{total})',
  'appointments.batch.selectAll': 'Seleziona tutto',
  'appointments.batch.error.selectTargetDate': 'Seleziona una data di destinazione',
  'appointments.batch.action.move': 'Sposta',
  'appointments.batch.action.duplicate': 'Duplica',
  'appointments.batch.operation.select': 'Seleziona operazione',
  'appointments.batch.operation.deleteLabel': 'Elimina appuntamenti selezionati',
  'appointments.batch.operation.moveLabel': 'Sposta appuntamenti selezionati',
  'appointments.batch.operation.duplicateLabel': 'Duplica appuntamenti selezionati',
  'appointments.batch.operation.deleteDescription': 'Questa azione eliminerà definitivamente {count} appuntamento/i. Non può essere annullata.',
  'appointments.batch.operation.moveDescription': 'Questa azione sposterà {count} appuntamento/i alla data selezionata mantenendo l\'orario originale.',
  'appointments.batch.operation.duplicateDescription': 'Questa azione creerà copie di {count} appuntamento/i nella data selezionata.',
  'appointments.batch.operation.chooseDescription': 'Scegli un\'operazione da eseguire sugli appuntamenti selezionati.',
};
